
import Swiper from '~/components/swiper'
import ProductCard from '~/components/product-card/ProductCard'
export default {
  components: {
    Swiper,
    ProductCard,
  },
  inject: ['wording'],
  data() {
    return {
      products: [],
    }
  },
  async beforeMount() {
    if (this.wording?.carousel_collectionHandle) {
      this.products = await this.fetchCollectionFromSearchSpring(
        this.wording.carousel_collectionHandle
      )
    }
  },
}
